import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Pagination } from "../pagination";

interface Props {
  options: any[];
  select: any[];
  setSelect: any;
  items: any[];
  sort: string;
  sortDirection: string;
  handleSort: (sortKey: string) => void;
  location?: any;
  offset: any;
  setOffset: any;
  totalPage: number;
  pagination?: boolean;
  limit: number;
  setLimit: any;
}

const styles = {
  multiValue: (base: any, state: any) => {
    return state.data.isFixed ? { ...base, backgroundColor: "gray" } : base;
  },
  multiValueLabel: (base: any, state: any) => {
    return state.data.isFixed
      ? { ...base, fontWeight: "bold", color: "white", paddingRight: 6 }
      : base;
  },
  multiValueRemove: (base: any, state: any) => {
    return state.data.isFixed ? { ...base, display: "none" } : base;
  },
  container: (x: any) => ({ ...x, borderRadius: 0 }),
  input: (x: any) => ({ ...x, borderRadius: 0 }),
  control: (x: any) => ({
    ...x,
    borderRadius: 0,
    backgroundColor: "transparent",
    borderStyle: "none",
  }),
  dropdownIndicator: (x: any) => ({
    ...x,
    borderRadius: 0,
    backgroundColor: "transparent",
    borderStyle: "none",
  }),
  menu: (x: any) => ({
    ...x,
    borderRadius: 0,
    borderStyle: "none",
  }),
};

export default function (props: Props) {
  return (
    <thead>
      <tr>
        <th colSpan={props.select.length + 1} style={{ padding: 0 }}>
          <Select
            styles={styles}
            classNamePrefix="form-control"
            closeMenuOnSelect={false}
            components={makeAnimated()}
            value={props.select}
            onChange={(e) => props.setSelect(e ? e : [])}
            isMulti
            options={props.options}
            isClearable={props.select.some((e) => !e.isFixed)}
          />
        </th>
      </tr>
      {props.pagination === true ||
        (props.pagination === undefined && (
          <tr>
            <th colSpan={props.select.length + 1} style={{ padding: 12 }}>
              <Pagination
                props={props}
                offset={props.offset}
                setOffset={props.setOffset}
                total={props.totalPage}
                display="FLEX"
                limit={props.limit}
                setLimit={props.setLimit}
              />
            </th>
          </tr>
        ))}
      <tr>
        <th className="text-center">No.</th>
        {props.items.map((item) => {
          let str = item.className;

          if (item.sortKey !== undefined) {
            if (props.sort === item.sortKey) {
              str = str + ` ${props.sortDirection}`;
            } else {
              str = str + ` sorting`;
            }
          }

          return (
            <th
              key={item.label}
              className={str}
              onClick={() =>
                item.sortKey ? props.handleSort(item.sortKey!) : {}
              }
            >
              {item.label}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
